import './styles.css';

import React, { useCallback, RefObject } from 'react';
import { Tooltip, useTooltip } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { CoreSvgSpriteIcon } from '@search/vtbeco-frontend-core/view/common/components/CoreSvgSpriteIcon/CoreSvgSpriteIcon';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import RoadBackground from './roadBackground.url.svg';

const cn = classname.bind(null, 'MapThumbnail');

export const MapThumbnail = ({
    mapRef,
    onClick
} : {
    mapRef: RefObject<HTMLDivElement | null>;
    onClick?: () => void;
}) => {
    const { to, registerControl } = useTooltip();
    const staticPath = useStaticPathConfig();

    const scrollTo = useCallback(() => {
        mapRef.current?.scrollIntoView({ block: 'center' });
        onClick?.();
    }, [ mapRef, onClick ]);

    return (
        <>
            <div
                // @ts-ignore
                ref={registerControl}
                className={cn()}
                onClick={scrollTo}
                style={{
                    backgroundImage: `url(${staticPath}${RoadBackground})`
                }}
            >
                <CoreSvgSpriteIcon
                    name='pin'
                    height={32}
                    width={32}
                    viewBoxWidth={48}
                    viewBoxHeight={48}
                />
            </div>
            <Tooltip direction='down' to={to}>Показать карту</Tooltip>
        </>
    );
};
